import React, { useEffect, useState } from "react";
import { useWebexContactCentre } from "../../../services/webex/contactcenter/WebexContactCentreProvider";
import { Button, Dropdown, Label, makeStyles, Option, tokens } from "@fluentui/react-components";
import { ApprovalsAppRegular } from "@fluentui/react-icons";
import { ActiveCallDetails } from "../ActiveCallDetails";
import { CONTACT_DIRECTION } from "../../../services/webex/contactcenter/models/IRoutingMessage";
import logger from "../../../utils/Logger";
import { useDynamics } from "../../../services/dynamics/DynamicsProvidor";
const styles = makeStyles({
    root: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        gap: "15px",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "4px",
        padding: "0 20px", // Add left and right padding of 20px
        margin: "20px 0", // Adjust margin to not interfere with padding
        boxSizing: "border-box",
    },
    currentCallTimerContainer: {
        backgroundColor: "#333",
        padding: "10px 20px",
        borderRadius: "4px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        color: "#fff",
    },
    currentCallTimer: {
        fontSize: "16px",
        color: "#fff",
    },
    currentCallIconRed: {
        fontSize: "22px",
        color: "rgb(209, 52, 56)",
        marginRight: "8px",
    },
    activeCallDetailsContainer: {
        padding: "15px",
        boxSizing: "border-box",
        width: "100%",
    },
    activeCallDetails: {
        padding: "12px 20px",
        boxSizing: "border-box",
        backgroundColor: tokens.colorNeutralBackground1Hover,
        width: "100%",
        borderRadius: "6px",
        border: `1px solid ${tokens.colorBrandForegroundInverted}`,
    },
    dropdown: {
        width: "100%",
    },
    button: {
        width: "100%",
        marginTop: "15px",
    },
});
export const WrapUpSection = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const webex = useWebexContactCentre();
    const classes = styles();
    const dynamics = useDynamics();
    const [wrapUpTime, setWrapUpTime] = useState(0);
    const [selectedWrapUpCode, setSelectedWrapUpCode] = useState(null);
    // Utility function to format time in hh:mm:ss or mm:ss format
    const formatTime = (seconds) => {
        const days = Math.floor(seconds / 86400);
        const hrs = Math.floor((seconds % 86400) / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        if (days > 0) {
            return `${days}d ${hrs}h ${mins < 10 ? "0" : ""}${mins}m ${secs < 10 ? "0" : ""}${secs}s`;
        }
        else if (hrs > 0) {
            return `${hrs}:${mins < 10 ? "0" : ""}${mins}:${secs < 10 ? "0" : ""}${secs}`;
        }
        else if (mins > 0) {
            return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
        }
        else {
            return `${secs} Sec`;
        }
    };
    // Update the wrap up time every second
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        const wrapUpStartTime = (_c = (_b = (_a = webex.task) === null || _a === void 0 ? void 0 : _a.agentState) === null || _b === void 0 ? void 0 : _b.wrapUpTimestamp) !== null && _c !== void 0 ? _c : (_e = (_d = webex.task) === null || _d === void 0 ? void 0 : _d.agentState) === null || _e === void 0 ? void 0 : _e.lastUpdated;
        if (wrapUpStartTime) {
            const interval = setInterval(() => {
                const currentTime = Date.now();
                const elapsedSeconds = Math.floor((currentTime - wrapUpStartTime) / 1000);
                setWrapUpTime(elapsedSeconds);
            }, 1000);
            return () => clearInterval(interval);
        }
        else {
            setWrapUpTime(0);
        }
    }, [(_b = (_a = webex.task) === null || _a === void 0 ? void 0 : _a.agentState) === null || _b === void 0 ? void 0 : _b.wrapUpTimestamp]);
    const handleCloseWrapUp = () => {
        var _a;
        logger.log("WrapUpSection", "Wrap-up closed with code:", selectedWrapUpCode);
        if ((_a = webex.task) === null || _a === void 0 ? void 0 : _a.interaction) {
            webex.wrapUpCall(webex.task.interaction.interactionId, selectedWrapUpCode);
        }
        else {
            logger.error("WrapUpSection", "No active call to wrap up");
        }
    };
    const handleWrapUpCodeChange = (event, data) => {
        setSelectedWrapUpCode(data.optionValue);
    };
    const callerId = ((_c = webex.task) === null || _c === void 0 ? void 0 : _c.interaction.contactDirection.type) === CONTACT_DIRECTION.OUTBOUND
        ? (_e = (_d = webex.task) === null || _d === void 0 ? void 0 : _d.interaction.callAssociatedDetails.dn) !== null && _e !== void 0 ? _e : "Unknown"
        : ((_f = webex.task) === null || _f === void 0 ? void 0 : _f.interaction.contactDirection.type) === CONTACT_DIRECTION.INBOUND
            ? (_h = (_g = webex.task) === null || _g === void 0 ? void 0 : _g.interaction.callAssociatedDetails.ani) !== null && _h !== void 0 ? _h : "Unknown"
            : "Unknown";
    const callFor = () => {
        var _a, _b, _c, _d, _e;
        const callVars = (_a = webex.task) === null || _a === void 0 ? void 0 : _a.contactCenterVariables;
        if (((_b = webex.task) === null || _b === void 0 ? void 0 : _b.interaction.contactDirection.type) !== CONTACT_DIRECTION.INBOUND) {
            return undefined;
        }
        if (callVars === null || callVars === void 0 ? void 0 : callVars.CallFor) {
            return (_c = webex.task) === null || _c === void 0 ? void 0 : _c.contactCenterVariables.CallFor;
        }
        if ((callVars === null || callVars === void 0 ? void 0 : callVars.Branch) && (callVars === null || callVars === void 0 ? void 0 : callVars.Department)) {
            return `${callVars.Branch} ${callVars.Department}`;
        }
        if (callVars === null || callVars === void 0 ? void 0 : callVars.Branch) {
            return callVars.Branch;
        }
        return (_e = (_d = webex.task) === null || _d === void 0 ? void 0 : _d.interaction.callAssociatedDetails.dn) !== null && _e !== void 0 ? _e : "Unknown";
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.currentCallTimerContainer },
            React.createElement(ApprovalsAppRegular, { className: classes.currentCallIconRed }),
            React.createElement(Label, { className: classes.currentCallTimer }, `Wrapup timer: ${formatTime(wrapUpTime)}`)),
        React.createElement("div", { className: classes.activeCallDetailsContainer },
            React.createElement(ActiveCallDetails, { className: classes.activeCallDetails, callDirection: (_j = webex.task) === null || _j === void 0 ? void 0 : _j.interaction.contactDirection.type, customerDescription: (_k = webex.task) === null || _k === void 0 ? void 0 : _k.contactCenterVariables.CustomerDisplayName, callerId: callerId, customerAccount: (_l = webex.task) === null || _l === void 0 ? void 0 : _l.contactCenterVariables.CustomerAccountNumber, customerBranch: (_m = webex.task) === null || _m === void 0 ? void 0 : _m.contactCenterVariables.CustomerBranch, callFor: callFor(), dynamicsCustomerAccounts: (_o = dynamics.matchingRecords) !== null && _o !== void 0 ? _o : null })),
        React.createElement(Dropdown, { className: classes.dropdown, placeholder: "Select Wrap-Up Code", onOptionSelect: handleWrapUpCodeChange }, [...webex.wrapUpOptions].sort((a, b) => a.name > b.name ? 1 : -1).map((option) => (React.createElement(Option, { key: option.id, value: option.id }, option.name)))),
        React.createElement(Button, { className: classes.button, appearance: "primary", onClick: handleCloseWrapUp, disabled: !selectedWrapUpCode }, "Submit Wrap-Up")));
};
